module.exports = __webpack_public_path__ + "static/fonts/Acumin-BdPro.31d32c6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Acumin-BdPro.woff
// module id = cXKg
// module chunks = 1